import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(tableInitSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(gridInitSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(tableApiSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(tableApiSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(tableUpdateApiSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(tableUpdateApiSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(tablesSaga);

import { all, call, fork, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { PopupsService } from '@services';
import { getTableSorts } from '@helpers';
import { ApiResponse, Popups } from '@enums';
import { TABLE_API_FETCH, TABLE_API_UPDATE, TABLE_INIT_REQUEST } from './tables.action-types';
import { actions } from './tables.actions';
import { getTableSelector } from './tables.selectors';

/**
 * Table init saga worker.
 *
 * @author Mikhail Siutsou
 * @function tableInitSagaWorker
 * @category Sagas
 * @subcategory Tables
 * @return {Generator<PutEffect>} action data.
 */
function tableInitSagaWorker(action) {
  return _regeneratorRuntime.wrap(function tableInitSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.tableInit({
            tableId: action.payload.tableId,
            items: null,
            isLoading: true
          }));

        case 2:
          _context.next = 4;
          return put(actions.tableUpdate({
            tableId: action.payload.tableId,
            items: action.payload.items,
            number: action.payload.number,
            totalElements: action.payload.totalElements,
            numberOfElements: action.payload.numberOfElements,
            totalPages: action.payload.totalPages,
            size: action.payload.size,
            search_value: action.payload.search_value,
            sorts: action.payload.sorts,
            filters: action.payload.filters
          }));

        case 4:
          _context.next = 6;
          return put(actions.tableUpdate({
            tableId: action.payload.tableId,
            isLoading: false
          }));

        case 6:
          _context.next = 8;
          return put(actions.tableSuccessRequest(action.payload.tableId));

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Table init saga watcher.
 *
 * @author Mikhail Siutsou
 * @function gridInitSagaWatcher
 * @category Sagas
 * @subcategory Tables
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function gridInitSagaWatcher() {
  return _regeneratorRuntime.wrap(function gridInitSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(TABLE_INIT_REQUEST, tableInitSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Table api saga worker.
 *
 * @author Mikhail Siutsou
 * @function tableApiSagaWorker
 * @category Sagas
 * @subcategory Tables
 * @return {Generator<PutEffect>} action data.
 */


function tableApiSagaWorker(action) {
  var response, axiosResponse, responseWithData, tableResponse, items, error;
  return _regeneratorRuntime.wrap(function tableApiSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return put(actions.tableInit({
            tableId: action.payload.tableId,
            items: null,
            isError: false,
            isLoading: true
          }));

        case 3:
          _context3.next = 5;
          return call(action.payload.api, {
            size: action.payload.size,
            page: action.payload.page,
            search_value: action.payload.search_value,
            sorts: getTableSorts(action.payload.sorts)
          });

        case 5:
          response = _context3.sent;
          axiosResponse = response;
          responseWithData = axiosResponse.data;
          tableResponse = axiosResponse.data;

          if (responseWithData) {
            if (action.payload.transformResponse) {
              items = action.payload.transformResponse(responseWithData);
            } else {
              items = (responseWithData === null || responseWithData === void 0 ? void 0 : responseWithData.content) || responseWithData;
            }
          } else {
            if (action.payload.transformResponse) {
              items = action.payload.transformResponse(responseWithData);
            } else {
              items = response;
            }
          }

          _context3.next = 12;
          return put(actions.tableUpdate({
            tableId: action.payload.tableId,
            items: items,
            number: tableResponse.number,
            totalElements: tableResponse.totalElements,
            totalPages: tableResponse.totalPages,
            numberOfElements: tableResponse.numberOfElements,
            size: tableResponse.size,
            search_value: action.payload.search_value,
            sorts: tableResponse.sort.unsorted ? [] : action.payload.sorts
          }));

        case 12:
          _context3.next = 14;
          return put(actions.tableUpdate({
            tableId: action.payload.tableId,
            isLoading: false
          }));

        case 14:
          _context3.next = 16;
          return put(actions.tableApiSuccess({
            tableId: action.payload.tableId
          }));

        case 16:
          _context3.next = 30;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3["catch"](0);
          error = _context3.t0;

          if (!(error.status === ApiResponse.Unauthorized)) {
            _context3.next = 26;
            break;
          }

          _context3.next = 24;
          return call(PopupsService.open, Popups.Error, {
            header: error.name,
            body: error.message
          });

        case 24:
          _context3.next = 30;
          break;

        case 26:
          _context3.next = 28;
          return put(actions.tableUpdate({
            tableId: action.payload.tableId,
            isLoading: false,
            isError: error,
            items: null
          }));

        case 28:
          _context3.next = 30;
          return put(actions.tableApiFailure({
            tableId: action.payload.tableId
          }));

        case 30:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 18]]);
}
/**
 * Table api saga watcher.
 *
 * @author Mikhail Siutsou
 * @function tableApiSagaWatcher
 * @category Sagas
 * @subcategory Tables
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function tableApiSagaWatcher() {
  return _regeneratorRuntime.wrap(function tableApiSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeEvery(TABLE_API_FETCH, tableApiSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Table update api saga worker.
 *
 * @author Mikhail Siutsou
 * @function tableUpdateApiSagaWorker
 * @category Sagas
 * @subcategory Tables
 * @return {Generator<PutEffect>} action data.
 */


function tableUpdateApiSagaWorker(action) {
  var table, _ref, page, search_value, size, sorts, filters, response, axiosResponse, responseWithData, tableResponse, items, error;

  return _regeneratorRuntime.wrap(function tableUpdateApiSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return select(getTableSelector(action.payload.tableId));

        case 3:
          table = _context5.sent;

          /* eslint-disable camelcase */
          _ref = table, page = _ref.page, search_value = _ref.search_value, size = _ref.size, sorts = _ref.sorts, filters = _ref.filters;
          /* eslint-enable camelcase */

          _context5.next = 7;
          return put(actions.tableUpdate({
            tableId: action.payload.tableId,
            isLoading: true,
            isError: false
          }));

        case 7:
          _context5.next = 9;
          return call(action.payload.api, {
            size: action.payload.size || size,
            page: typeof action.payload.page !== 'undefined' ? action.payload.page : page,

            /* eslint-disable camelcase */
            search_value: typeof action.payload.search_value === 'string' ? action.payload.search_value : search_value,

            /* eslint-enable camelcase */
            sorts: getTableSorts(action.payload.sorts) || getTableSorts(sorts)
          });

        case 9:
          response = _context5.sent;
          axiosResponse = response;
          responseWithData = axiosResponse.data;
          tableResponse = axiosResponse.data;

          if (responseWithData) {
            if (action.payload.transformResponse) {
              items = action.payload.transformResponse(responseWithData);
            } else {
              items = (responseWithData === null || responseWithData === void 0 ? void 0 : responseWithData.content) || responseWithData;
            }
          } else {
            if (action.payload.transformResponse) {
              items = action.payload.transformResponse(responseWithData);
            } else {
              items = response;
            }
          }

          _context5.next = 16;
          return put(actions.tableUpdate({
            tableId: action.payload.tableId,
            items: items,
            number: tableResponse.number,
            totalElements: tableResponse.totalElements,
            totalPages: tableResponse.totalPages,
            numberOfElements: tableResponse.numberOfElements,
            size: tableResponse.size,

            /* eslint-disable camelcase */
            search_value: typeof action.payload.search_value === 'string' ? action.payload.search_value : search_value,

            /* eslint-enable camelcase */
            sorts: tableResponse.sort.unsorted ? [] : action.payload.sorts || sorts,
            filters: action.payload.filters || filters || []
          }));

        case 16:
          _context5.next = 18;
          return put(actions.tableUpdate({
            tableId: action.payload.tableId,
            isLoading: false
          }));

        case 18:
          _context5.next = 20;
          return put(actions.tableApiSuccess({
            tableId: action.payload.tableId
          }));

        case 20:
          _context5.next = 34;
          break;

        case 22:
          _context5.prev = 22;
          _context5.t0 = _context5["catch"](0);
          error = _context5.t0;

          if (!(error.status === ApiResponse.Unauthorized)) {
            _context5.next = 30;
            break;
          }

          _context5.next = 28;
          return call(PopupsService.open, Popups.Error, {
            header: error.name,
            body: error.message
          });

        case 28:
          _context5.next = 34;
          break;

        case 30:
          _context5.next = 32;
          return put(actions.tableUpdate({
            tableId: action.payload.tableId,
            isLoading: false,
            isError: error,
            items: null
          }));

        case 32:
          _context5.next = 34;
          return put(actions.tableApiFailure({
            tableId: action.payload.tableId
          }));

        case 34:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 22]]);
}
/**
 * Table update api saga watcher.
 *
 * @author Mikhail Siutsou
 * @function tableUpdateApiSagaWatcher
 * @category Sagas
 * @subcategory Tables
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function tableUpdateApiSagaWatcher() {
  return _regeneratorRuntime.wrap(function tableUpdateApiSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeEvery(TABLE_API_UPDATE, tableUpdateApiSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * Tables saga.
 *
 * @author Mikhail Siutsou
 * @function tablesSaga
 * @category Sagas
 * @subcategory Tables
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


export default function tablesSaga() {
  return _regeneratorRuntime.wrap(function tablesSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return all([fork(gridInitSagaWatcher), fork(tableApiSagaWatcher), fork(tableUpdateApiSagaWatcher)]);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}